"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnergySaving = void 0;
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var Size_1 = require("../render/Size");
var CardRenderer_1 = require("../render/CardRenderer");
var Options_1 = require("../Options");
var EnergySaving = (function (_super) {
    __extends(EnergySaving, _super);
    function EnergySaving() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.ENERGY_SAVING,
            tags: [Tags_1.Tags.ENERGY],
            cost: 15,
            metadata: {
                cardNumber: '189',
                description: 'Increase your Energy production 1 step for each City tile in play.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.energy(1).slash().city({ size: Size_1.Size.SMALL, all: Options_1.all }); });
                }),
            },
        }) || this;
    }
    EnergySaving.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.ENERGY, player.game.getCitiesInPlay(), { log: true });
        return undefined;
    };
    return EnergySaving;
}(Card_1.Card));
exports.EnergySaving = EnergySaving;
